import { SYSTEM_LIMITS } from 'common';
import { sortableContainer } from 'react-sortable-hoc';
import Tooltip from 'style-guide/Tooltip';
import SortableChapterItem from '../SortableChapterItem';

const { LIST } = SYSTEM_LIMITS.COURSE_CONTENT.CHAPTERS;

const SortableChapterList = sortableContainer(({ volume, isPreview }) => (
  <div>
    {volume.chapters?.map((chapter, index) => (
      <Tooltip overlay='Complete previous chapters to unlock this one' placement='top' $disabled={chapter.showChapter}>
        <SortableChapterItem
          data={chapter}
          key={chapter.id}
          index={index}
          isLast={volume.chapters.length === LIST.min}
          isPreview={isPreview}
        />
      </Tooltip>
    ))}
  </div>
));

export default SortableChapterList;
